import { Fragment } from 'react';

import { Link, useMatchRoute } from '@tanstack/react-router';

import {
    Sidebar,
    SidebarContent,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarProvider,
    SidebarSeparator,
} from '@nesso/ui/primitives/sidebar';

import { useSettingsNavGroups } from '../../model/use-settings-nav-groups';

export function SettingsLayoutSidebar() {
    // react compiler issue : isn't work correctly with useMatchRoute
    'use no memo';
    const matchRoute = useMatchRoute();
    const navGroups = useSettingsNavGroups();

    return (
        <SidebarProvider defaultOpen={true} className="min-h-0">
            <Sidebar collapsible="none" className="w-full">
                <SidebarContent className="bg-background py-6 px-1 sm:px-6">
                    {navGroups.map((group, index) => (
                        <Fragment key={group.label}>
                            {index > 0 && <SidebarSeparator className="mx-0" />}
                            <SidebarGroup className="p-2 gap-2">
                                <SidebarGroupLabel className="text-sidebar-foreground">
                                    {group.label}
                                </SidebarGroupLabel>
                                <SidebarGroupContent>
                                    <SidebarMenu className="gap-3">
                                        {group.items.map((item) => {
                                            const isActive = !!matchRoute({
                                                to: item.to,
                                                includeSearch: false,
                                            });
                                            return (
                                                <SidebarMenuItem key={item.to} className="p-0">
                                                    <SidebarMenuButton asChild isActive={isActive}>
                                                        <Link to={item.to}>
                                                            <item.icon />
                                                            <span className="text-sm">
                                                                {item.label}
                                                            </span>
                                                        </Link>
                                                    </SidebarMenuButton>
                                                </SidebarMenuItem>
                                            );
                                        })}
                                    </SidebarMenu>
                                </SidebarGroupContent>
                            </SidebarGroup>
                        </Fragment>
                    ))}
                </SidebarContent>
            </Sidebar>
        </SidebarProvider>
    );
}
